export default __webpack_public_path__ + "static/media/Group 3056.40c69b05.png";